import React, { useEffect, useRef, useState } from 'react';

/**
 * AnimatedSection - Wraps content and animates it when it scrolls into view
 * Uses Intersection Observer for performance
 */
export default function AnimatedSection({ 
  children, 
  className = '', 
  animation = 'fade-up', // 'fade-up', 'fade-left', 'scale'
  delay = 0
}) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const animationClass = {
    'fade-up': 'scroll-animate',
    'fade-left': 'scroll-animate-left',
    'scale': 'scroll-animate-scale'
  }[animation] || 'scroll-animate';

  const delayClass = delay > 0 ? `scroll-delay-${delay}` : '';

  return (
    <div 
      ref={ref} 
      className={`${animationClass} ${isVisible ? 'visible' : ''} ${delayClass} ${className}`}
    >
      {children}
    </div>
  );
}
